export enum ViewGridSearchBlock {
  Root = 'ViewGridSearch',
}

export enum ViewGridSearchElement {
  AdditionalControls = 'additionalControls',
}
